/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Namespaces } from '../../i18n';
import { ConvertibleCanvas } from '../../miscellaneous/ConvertibleCanvas';
import { EditPhoto, EditPhotoHelpers, EditPhotoProps } from '../EditPhoto/EditPhoto';
import { useEventCallback } from '../hooks/useEventCallback';
import { HUModal2, HUModal2Props } from '../HUModal2/HUModal2';

type EditPhotoModalProps = Pick<HUModal2Props, 'open' | 'size'> &
  Omit<EditPhotoProps, 'onChange'> & {
    onSave: (canvas: ConvertibleCanvas) => any;
    onCancel: () => any;
  };

export function EditPhotoModal(props: EditPhotoModalProps) {
  const { open, size, onSave, onCancel, ...editPhotoProps } = props;
  const { t } = useTranslation([Namespaces.General]);

  const editorRef = useRef<EditPhotoHelpers>(null);

  const onOk = useEventCallback(async () => {
    if (editorRef.current) {
      const canvas = await editorRef.current.getNewImage();
      onSave(canvas!);
    }
  });

  return (
    <HUModal2
      open={open}
      size={size}
      okButtonText={t('edit_photo_modal.ok_button')}
      cancelButtonText={t('edit_photo_modal.cancel_button')}
      onOk={onOk}
      onCancel={onCancel}
      title={t('edit_photo_modal.title')}
    >
      <EditPhoto {...editPhotoProps} ref={editorRef} />
    </HUModal2>
  );
}
